import $ from 'jquery';
import MembershipUtils from './../../shared/Membership';
import {ANONYMOUS_TIER_URL} from './../../shared/Membership';

export default () => {
    const $urls = $('a[href*="' + ANONYMOUS_TIER_URL + '"]');
    MembershipUtils.changeCtaElementUrl($urls);
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/MembershipPageUpdate/urlTiersCTAUpdate.js